import { render, staticRenderFns } from "./CashDesksList.vue?vue&type=template&id=4f737e66"
import script from "./CashDesksList.vue?vue&type=script&lang=js"
export * from "./CashDesksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports